export const LOGOUT_USER_FROM_TOOLS = 'LOGOUT_USER_FROM_TOOLS';
export const LOGOUT_USER_FROM_UA = 'LOGOUT_USER_FROM_UA';

export const logoutUserFromTools = ({ userId }) => ({
  type: LOGOUT_USER_FROM_TOOLS,
  payload: {
    userId
  }
});

export const logoutUserFromUa = ({ userId }) => ({
  type: LOGOUT_USER_FROM_UA,
  payload: {
    userId
  }
});
